/** @type {string[]} */
export default [
	'Genesis Berge',
	'Loren Terry',
	'Dr. Ceasar Harber IV',
	'Prof. Jared Yost II',
	'Lauren Ipsum',
	'Michael Dolor',
	'Linda Consectetur-Maecenas',
	'John Doe',
	'Jane Smith',
	'Robert Johnson',
	'Mary Williams',
	'James Brown',
	'Patricia Davis',
	'Charles Miller',
	'Jennifer Wilson',
	'Joseph Moore',
	'Margaret Taylor',
	'Thomas Anderson',
	'Jessica Thomas',
	'William Jackson',
	'Susan White',
	'David Harris',
	'Sarah Martin',
	'Richard Thompson',
	'Karen Garcia',
	'Paul Martinez',
	'Nancy Robinson',
	'Mark Clark',
];
